import {
  AccessRuleEntitlementContext,
  PersistedEffectiveDateRangeAccessRulePayload,
} from "../productAdministration/accessRules/models";

export const AUTH0_USER_PREFIX = "auth0|";

/**
 * Hard-coding to 2 for now but this could be a config value if there is a need for it to be changed
 * without making code changes
 */
export const NUMBER_OF_HISTORY_EVENT_ROWS = 2;

export enum LIFT_ACCESS_RULE_EVENT_CATEGORY {
  EFFECTIVE_DATE_UPDATED = 0,
  EXPIRATION_DATE_UPDATED = 1,
}

export interface LiftAccessRuleHistory {
  entitlementTypeId: number;
  resortId: number;
  fulfillmentSeasonId: number;
  historyEventDetails: LiftAccessRuleEventDetail[];
}

export interface LiftAccessRuleEventDetail {
  eventCategory: LIFT_ACCESS_RULE_EVENT_CATEGORY;
  modifiedBy: string;
  modifiedByName: string;
  modifiedUtcDateTime: string;
  newValue: string;
  modifiedDateFormatted: string;
  valueFormatted: string;
}

export interface EditableEffectiveDateRangeAccessRule {
  liftAccessRuleId: number;
  entitlementTypeId: number;
  fulfillmentSeasonId: number;
  resortId: number;
  product: string;
  season: string;
  fulfillmentSeason: string;
  effectiveDate: string;
  expirationDate: string;
  effectiveTimeSlotStart: string;
  effectiveTimeSlotEnd: string;
}

export interface ValidationConfiguration {
  resortAbbreviation: string;
  effectiveDateRangeRules: EditableEffectiveDateRangeAccessRule[];
  effectiveDateRangeHistory: LiftAccessRuleHistory[];
}

export type ValidationConfigurationChangeSet = {
  context: AccessRuleEntitlementContext;
  rule: PersistedEffectiveDateRangeAccessRulePayload;
};

export type ValidationConfigurationUpdateRequest = {
  operatorId: string;
  userId: string;
  requestUtcDateTime: string;
  resortAbbreviation: string;
  updateHierarchyChildEntitlementTypes: boolean;
  updateBenefitChildEntitlementTypes: boolean;
  effectiveDateRangeRuleUpdates: ValidationConfigurationChangeSet[];
};
